<div class="row">

  <div class="col-12 col-xl-8">

    <!-- Day header with progress -->
    <div class="agenda-card p-3 p-md-4 mb-3">
      <div class="d-flex align-items-start justify-content-between">
        <div>
          <p class="fs-xsmall fw-800 color-brand-primary-700 mb-1">{{today.format('D MMMM dddd')|uppercase}}</p>
          <p class="fs-20 fw-800 color-gray-950 mb-0">{{'agenda.daily.title'|translate}}</p>
        </div>

        <div class="text-end">
          <p class="fs-20 fw-800 color-gray-950 mb-0">
            {{completedCount()}}<span class="fs-normal color-gray-400">/{{totalCount()}}</span>
          </p>
          <p class="fs-xsmall fw-400 color-gray-400 mb-0">{{'agenda.daily.completed_label'|translate}}</p>
        </div>
      </div>

      <div class="progress-track mt-3">
        <div class="progress-value" [style.width.%]="progressPercent()"></div>
      </div>
    </div>

    <!-- Meetings -->
    <ngx-skeleton-loader
      *ngIf="isLoading" count="3" appearance="line"
      [theme]="{height: '76px', 'border-radius': '16px', margin: '0 0 8px 0'}"/>

    <div class="agenda-card p-5 text-center" *ngIf="!todayAppointments.length && !isLoading">
      <p class="fs-normal fw-800 color-gray-950 mb-1">{{'agenda.daily.empty_title'|translate}}</p>
      <p class="fs-small fw-400 color-gray-400 mb-0">{{'agenda.daily.empty_desc'|translate}}</p>
    </div>

    <div
      class="agenda-card meeting-row d-flex flex-column flex-md-row align-items-md-center justify-content-between p-3 mb-2"
      *ngFor="let item of todayAppointments" [class.next]="stateOf(item) === 'next'">

      <div class="d-flex align-items-center">
        <div class="time-box text-center me-3">
          <p class="fs-20 fw-800 mb-0" [class.color-brand-primary-700]="stateOf(item) === 'next'"
             [class.color-gray-950]="stateOf(item) !== 'next'">{{item.startsAt|date:'HH:mm'}}</p>
          <p class="fs-xsmall fw-400 color-gray-400 mb-0">
            <i class="bi bi-clock me-1"></i>{{'agenda.daily.duration'|translate: {minutes: durationMinutes(item)} }}
          </p>
        </div>

        <coach-student-avatar
          class="me-3" [name]="item.student?.name" [levelKey]="levelKey(item)"></coach-student-avatar>

        <div class="overflow-hidden">
          <p class="fs-normal fw-800 color-gray-950 mb-0 text-truncate">{{item.student?.name}}</p>
          <p class="fs-small fw-400 color-gray-400 mb-0 text-truncate">{{item.title}}</p>
        </div>
      </div>

      <div class="d-flex align-items-center mt-3 mt-md-0">
        <span class="state-badge completed fs-xsmall fw-800 me-2" *ngIf="stateOf(item) === 'completed'">
          <i class="bi bi-check-circle me-1"></i>{{'agenda.daily.state_completed'|translate}}
        </span>
        <span class="state-badge next fs-xsmall fw-800 me-2" *ngIf="stateOf(item) === 'next'">
          {{'agenda.daily.state_next'|translate}}
        </span>
        <span class="state-badge upcoming fs-xsmall fw-800 me-2" *ngIf="stateOf(item) === 'upcoming'">
          {{'agenda.daily.state_upcoming'|translate}}
        </span>
        <span class="state-badge past fs-xsmall fw-800 me-2" *ngIf="stateOf(item) === 'past'">
          {{'agenda.daily.state_past'|translate}}
        </span>

        <app-gray-button
          *ngIf="(stateOf(item) === 'next') && item.meetLink"
          color="primary" [fullWidth]="false" padding="p-0" [weight]="800"
          customClass="join-btn fs-small me-2" preIcon="videos"
          [text]="'agenda.join_meeting'|translate" (click)="openMeetLink(item)"></app-gray-button>

        <a class="open-student fs-small fw-500 color-gray-500 clickable" (click)="openStudent(item.student?.id)">
          {{'agenda.daily.open_student'|translate}} <i class="bi bi-chevron-right"></i>
        </a>
      </div>
    </div>

    <!-- Closing the day -->
    <div class="agenda-card p-3 p-md-4 mt-3">
      <div class="d-flex align-items-start justify-content-between mb-3">
        <div>
          <p class="fs-20 fw-800 color-gray-950 mb-0">{{'agenda.daily.close_day'|translate}}</p>
          <p class="fs-small fw-400 color-gray-400 mb-0">
            {{'agenda.daily.close_day_desc'|translate: {date: today.format('D MMMM dddd')} }}
          </p>
        </div>
        <span class="badge-soft fs-xsmall fw-800">
          {{'agenda.daily.close_day_progress'|translate: {completed: completedCount(), total: totalCount()} }}
        </span>
      </div>

      <div class="row">
        <div class="col-12 col-lg-6 mb-3 mb-lg-0">
          <div class="close-box p-3 h-100">
            <p class="fs-small fw-800 color-gray-950 mb-2">{{'agenda.daily.yesterday_open'|translate}}</p>
            <p class="fs-small fw-400 color-gray-400 mb-0" *ngIf="!yesterdayOpen.length">—</p>
            <a class="close-item d-block clickable py-2" *ngFor="let item of yesterdayOpen"
               (click)="openStudent(item.student?.id)">
              <p class="fs-small fw-800 color-gray-950 mb-0">{{item.student?.name}}</p>
              <p class="fs-xsmall fw-400 color-gray-400 mb-0">{{item.startsAt|date:'HH:mm'}} · {{item.title}}</p>
            </a>
          </div>
        </div>

        <div class="col-12 col-lg-6">
          <div class="close-box p-3 h-100">
            <p class="fs-small fw-800 color-gray-950 mb-2">{{'agenda.daily.tomorrow'|translate}}</p>
            <p class="fs-small fw-400 color-gray-400 mb-0" *ngIf="!tomorrowAppointments.length">—</p>
            <a class="close-item d-block clickable py-2" *ngFor="let item of tomorrowAppointments"
               (click)="openStudent(item.student?.id)">
              <p class="fs-small fw-800 color-gray-950 mb-0">{{item.student?.name}}</p>
              <p class="fs-xsmall fw-400 color-gray-400 mb-0">{{item.startsAt|date:'HH:mm'}} · {{item.title}}</p>
            </a>
          </div>
        </div>
      </div>
    </div>

  </div>

  <!-- Side panel -->
  <div class="col-12 col-xl-4 mt-3 mt-xl-0">

    <div class="agenda-card p-3 p-md-4 mb-3">
      <p class="fs-small fw-800 color-gray-500 mb-2">{{'agenda.daily.pending_requests'|translate|uppercase}}</p>
      <p class="fs-20 fw-800 color-brand-primary mb-0">{{rescheduleRequests.length}}</p>
      <p class="fs-small fw-400 color-gray-400 mb-0">{{'agenda.daily.pending_requests_desc'|translate}}</p>
    </div>

    <div class="agenda-card p-3 p-md-4">
      <p class="fs-small fw-800 color-gray-500 mb-2">{{'agenda.daily.quick_note'|translate|uppercase}}</p>

      <form [formGroup]="fgNote" (ngSubmit)="saveNote()">
        <textarea
          class="note-textarea w-100" formControlName="content"
          [placeholder]="'agenda.daily.quick_note_placeholder'|translate"></textarea>
        <div class="form-errors mt-1" *ngIf="noteIsSubmitted && fgNote.get('content')?.errors">
          <p>{{'errors.required'|translate}}</p>
        </div>

        <app-gray-button
          type="submit" color="primary" [weight]="800" padding="p-0"
          customClass="note-btn fs-small mt-2"
          [isLoading]="noteIsLoading" [disabled]="noteIsLoading"
          [text]="'agenda.daily.save_note'|translate"></app-gray-button>
      </form>

      <div class="mt-4" *ngIf="notesIsLoading">
        <p class="fs-small fw-800 color-gray-500 mb-2">{{'agenda.daily.notes_title'|translate|uppercase}}</p>
        <ngx-skeleton-loader
          count="2" appearance="line"
          [theme]="{height: '64px', 'border-radius': '12px', margin: '0 0 8px 0'}"/>
      </div>

      <div class="mt-4" *ngIf="quickNotes.length && !notesIsLoading">
        <p class="fs-small fw-800 color-gray-500 mb-2">{{'agenda.daily.notes_title'|translate|uppercase}}</p>

        <div class="note-item d-flex align-items-start p-3 mb-2" *ngFor="let note of quickNotes">
          <div class="flex-grow-1 overflow-hidden">
            <p class="fs-small fw-500 color-gray-950 mb-1">{{note.content}}</p>
            <p class="fs-xsmall fw-400 color-gray-400 mb-0">{{note.createdAt|date:'d MMMM, HH:mm'}}</p>
          </div>

          <a
            class="note-delete clickable ms-auto ps-2" (confirm)="deleteNote(note)" [swal]="{
              text: ('toastr.sure_remove'|translate),
              showDenyButton: false,
              showCancelButton: true,
              cancelButtonText: 'buttons.cancel_l'|translate,
              confirmButtonText: 'buttons.yes'|translate,
              heightAuto: false
            }">
            <i class="bi bi-trash" [ngbTooltip]="'buttons.remove'|translate" container="body"></i>
          </a>
        </div>
      </div>
    </div>

  </div>

</div>
